import { FetchBaseQueryMeta } from '@reduxjs/toolkit/query';
import { apiSlice } from '../apiSlice';
import { ReportGenerateRequest } from '../DTO/report/report.interface';

export interface ReportFileResult {
	blob: Blob;
	filename?: string;
}

// Parse the filename out of a Content-Disposition header.
// Handles both `filename*=UTF-8''foo.xlsx` and `filename="foo.xlsx"`.
function parseContentDisposition(header?: string | null): string | undefined {
	if (!header) return undefined;

	const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
	if (utf8Match?.[1]) {
		try {
			return decodeURIComponent(utf8Match[1].trim());
		} catch {
			return utf8Match[1].trim();
		}
	}

	const plainMatch = header.match(/filename="?([^";]+)"?/i);
	if (plainMatch?.[1]) return plainMatch[1].trim();

	return undefined;
}

export const reportApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		generateReport: builder.mutation<ReportFileResult, ReportGenerateRequest>({
			query: (req) => ({
				url: `/web/reports/generate`,
				method: 'POST',
				params: {
					start: req.start,
					end: req.end,
					series: req.series,
					'has-online': req.hasOnline,
				},
				body: {
					reportType: req.type,
				},
				responseHandler: (response) => response.blob(),
				cache: 'no-cache',
			}),
			transformResponse: (blob: Blob, meta) => ({
				blob,
				filename: parseContentDisposition(
					(meta as FetchBaseQueryMeta | undefined)?.response?.headers.get(
						'content-disposition'
					)
				),
			}),
		}),
	}),
});

export const { useGenerateReportMutation } = reportApiSlice;
